import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PeripheralService } from "@foundation/_services/peripheral.service";
import { IPlot } from "@interfaces/IPlot";
import { ISensorData } from "@interfaces/ISensorData";
import { Observable } from "rxjs";
import { IEngineerCommission } from "../../foundation.interfaces";
import { IEngineerCommissionQueryOptions } from "../../_models/IEngineerCommissionQueryOptions";
import { ISerialSearchResponse } from "../../_models/ISerialSearchResponse";
import { FoundationSensorDataService } from "../../_services/sensor-data.service";
import { UnitsService } from "../../_services/unit.service";

@Injectable({
    providedIn: 'root'
})
export class CommissionService {
    constructor(
        private readonly http: HttpClient,
        private readonly peripheralService: PeripheralService,
        private readonly sensorDataService: FoundationSensorDataService,
        private readonly unitService: UnitsService) {
    }

    getEngineerCommissions(params: IEngineerCommissionQueryOptions): Observable<IEngineerCommission[]> {
        if (params.Start) {
            params.Start = new Date(params.Start).toISOString();
        }

        if (params.End) {
            params.End = new Date(params.End).toISOString();
        }

        return this.http.get<IEngineerCommission[]>(`/api/foundation/engineerCommissions/`, { params: params as HttpParams })

    }

    getUnitOrPeripheralBySerial(serial: string): Observable<ISerialSearchResponse> {
        return this.unitService.getUnitBySerial(serial);
    }

    createUnitLabel(searchResponse: ISerialSearchResponse): string {
        if (!searchResponse) {
            return "";
        }

        if (searchResponse.Product) {
            return `${searchResponse.vendorString ? searchResponse.vendorString:''} ${searchResponse.Product.Description}`;
        }

        return "Product Information Unavailable";
    }

    getPlotsByImei(imei: string, jobItemVehicleId?: number): Observable<IPlot[]> {
        return this.peripheralService.getExtendedPlotsByImei(imei, jobItemVehicleId);
    }

    getSensorDataByImei(imei: string, startTime: Date): Observable<ISensorData[]> {
        return this.sensorDataService.getSensorDataByImei(imei, startTime, new Date());
    }
}
